// frontend/src/components/Layout/configs/layoutConfigs.ts
// FIXED: Updated with proper booking navigation for all roles

import {
  Home,
  Users,
  Settings,
  BarChart3,
  Shield,
  Activity,
  Package,
  MessageSquare,
  Calendar,
  MapPin,
  Briefcase,
  TrendingUp,
  Database,
  UserCheck,
  Bell,
  Globe,
  BookOpen,
  Search,
  FolderTree,
  CheckCircle,
  Clock,
  AlertCircle,
  User,Target
} from 'lucide-react';
import { LayoutConfig } from '../BaseLayout';

// 🔵 ADMIN LAYOUT CONFIGURATION - UPDATED WITH BOOKING ROUTES
export const adminLayoutConfig: LayoutConfig = {
  title: 'atmyarea',
  subtitle: 'Admin Dashboard',
  theme: {
    primary: 'bg-blue-600',
    secondary: 'bg-blue-50',
    accent: 'text-blue-600',
    sidebar: 'bg-white',
    text: 'text-white',
  },
  navigation: [
    {
      name: 'Dashboard',
      href: '/dashboard',
      icon: Home,
    },
    {
      name: 'User Management',
      href: '/users',
      icon: Users,
      requiredRoles: ['admin', 'super_admin'],
      badge: 'New'
    },
    {
      name: 'Provider Management',
      href: '/providers',
      icon: Shield,
      requiredRoles: ['admin', 'super_admin'],
      children: [
        { name: 'All Providers', href: '/providers', icon: UserCheck },
        { name: 'Provider Areas', href: '/provider-areas', icon: MapPin },
        { name: 'Provider Services', href: '/provider-services', icon: Package },
      ],
    },
    {
      name: 'Service Management',
      href: '/service-types',
      icon: Activity,
      requiredRoles: ['admin', 'super_admin'],
      children: [
        { name: 'Categories', href: '/categories', icon: FolderTree },
        { name: 'Service Types', href: '/service-types', icon: Package },
      ],
    },
    {
      name: 'Booking Management',
      href: '/bookings',
      icon: MessageSquare,
      requiredRoles: ['admin', 'super_admin'],
      badge: '12',
      children: [
        { name: 'All Bookings', href: '/bookings', icon: MessageSquare },
        { name: 'Pending', href: '/bookings/pending', icon: Clock },
        { name: 'Active', href: '/bookings/accepted', icon: AlertCircle },
        { name: 'Completed', href: '/bookings/completed', icon: CheckCircle },
      ],
    },
    {
      name: 'Profile & Setup',
      href: '/profile', // UPDATED: Changed from /profile to /business-profile
      icon: UserCheck,
      children: [
        { 
          name: 'My Profiles', // UPDATED: Changed from "Account Settings" to "My Profiles"
          href: '/profile', // UPDATED: Changed from /settings to /profile
          icon: User // UPDATED: Changed icon from Settings to User
        },
      ],
    },
    {
      name: 'System',
      href: '/analytics',
      icon: Database,
      requiredRoles: ['admin', 'super_admin'],
      children: [
        { name: 'Analytics', href: '/analytics', icon: BarChart3 },
        { name: 'Settings', href: '/settings', icon: Settings },
      ],
    },
  ],
  showSearch: true,
  showNotifications: true,
};

// 🟢 PROVIDER LAYOUT CONFIGURATION - UPDATED WITH BOOKING ROUTES
// 🟢 PROVIDER LAYOUT CONFIGURATION - UPDATED WITH NEW ROUTES
export const providerLayoutConfig: LayoutConfig = {
  title: 'atmyarea',
  subtitle: 'Provider Dashboard',
  theme: {
    primary: 'bg-green-600',
    secondary: 'bg-green-50',
    accent: 'text-green-600',
    sidebar: 'bg-white',
    text: 'text-white',
  },
  navigation: [
    {
      name: 'Dashboard',
      href: '/dashboard',
      icon: Home,
    },
    {
      name: 'Profile & Setup',
      href: '/business-profile', // UPDATED: Changed from /profile to /business-profile
      icon: UserCheck,
      children: [
        { 
          name: 'Business Profile', 
          href: '/business-profile', // UPDATED: Changed from /profile to /business-profile
          icon: Briefcase 
        },
        { 
          name: 'My Profiles', // UPDATED: Changed from "Account Settings" to "My Profiles"
          href: '/profile', // UPDATED: Changed from /settings to /profile
          icon: User // UPDATED: Changed icon from Settings to User
        },
      ],
    },
    {
      name: 'My Services',
      href: '/services',
      icon: Package,
      children: [
        { name: 'All Services', href: '/provider-services', icon: Package },
        { name: 'Service Areas', href: '/provider-areas', icon: MapPin },
      ],
    },
    {
      name: 'Bookings',
      href: '/bookings',
      icon: MessageSquare,
      badge: '5',
      children: [
        { name: 'All Requests', href: '/bookings', icon: MessageSquare },
        { name: 'Pending', href: '/bookings/pending', icon: Clock },
        { name: 'Active', href: '/bookings/accepted', icon: AlertCircle },
        { name: 'Completed', href: '/bookings/completed', icon: CheckCircle },
      ],
    },
    {
      name: 'Analytics',
      href: '/analytics',
      icon: BarChart3,
      children: [
        { name: 'Overview', href: '/analytics', icon: BarChart3 },
        { name: 'Revenue', href: '/analytics/revenue', icon: TrendingUp },
        { name: 'Performance', href: '/analytics/performance', icon: Target },
      ],
    },
    {
      name: 'Settings',
      href: '/settings',
      icon: Settings,
      children: [
        { name: 'Preferences', href: '/settings', icon: Settings },
        { name: 'Notifications', href: '/settings/notifications', icon: Bell },
        { name: 'Availability', href: '/settings/availability', icon: Calendar },
      ],
    },
  ],
  showSearch: true,
  showNotifications: true,
};

// 🟡 CUSTOMER LAYOUT CONFIGURATION (Traditional Dashboard Style)
export const customerLayoutConfig: LayoutConfig = {
  title: 'atmyarea',
  subtitle: 'Customer Dashboard',
  theme: {
    primary: 'bg-purple-600',
    secondary: 'bg-purple-50',
    accent: 'text-purple-600',
    sidebar: 'bg-white',
    text: 'text-white',
  },
  navigation: [
    {
      name: 'Dashboard',
      href: '/dashboard',
      icon: Home,
    },
    {
      name: 'Find Services',
      href: '/services',
      icon: Search,
    },
    {
      name: 'My Bookings',
      href: '/requests', // Legacy route compatibility
      icon: MessageSquare,
      badge: '2',
    },
    {
      name: 'Account',
      href: '/account', // Link to customer account layout
      icon: UserCheck,
    },
  ],
  showSearch: true,
  showNotifications: true,
};

// 🔘 PUBLIC LAYOUT CONFIGURATION (for marketing pages)
export const publicLayoutConfig: LayoutConfig = {
  title: 'atmyarea',
  subtitle: 'Connect. Service. Succeed.',
  theme: {
    primary: 'bg-gray-800',
    secondary: 'bg-gray-50',
    accent: 'text-gray-800',
    sidebar: 'bg-white',
    text: 'text-white',
  },
  navigation: [
    {
      name: 'Home',
      href: '/',
      icon: Home,
    },
    {
      name: 'Services',
      href: '/services',
      icon: Package,
    },
    {
      name: 'How It Works',
      href: '/how-it-works',
      icon: BookOpen,
    },
    {
      name: 'Become a Provider',
      href: '/join-provider',
      icon: Shield,
    },
    {
      name: 'About',
      href: '/about',
      icon: Globe,
    },
  ],
  showSearch: true,
  showNotifications: false,
};

// 🎯 CONFIGURATION SELECTOR FUNCTIONS
export const getLayoutConfigForRole = (userRole?: string): LayoutConfig => {
  switch (userRole) {
    case 'admin':
    case 'super_admin':
      return adminLayoutConfig;
    
    case 'provider':
      return providerLayoutConfig;
    
    case 'user':
    case 'customer':
      return customerLayoutConfig;
    
    default:
      return publicLayoutConfig;
  }
};

// 🔧 LAYOUT TYPE DEFINITIONS
export type LayoutType = 'admin' | 'provider' | 'customer' | 'customer-account' | 'public' | 'smart';

export const getLayoutConfig = (layoutType: LayoutType): LayoutConfig => {
  switch (layoutType) {
    case 'admin':
      return adminLayoutConfig;
    case 'provider':
      return providerLayoutConfig;
    case 'customer':
      return customerLayoutConfig;
    case 'customer-account':
      return customerLayoutConfig; // Fallback, CustomerAccountLayout uses its own navigation
    case 'public':
      return publicLayoutConfig;
    case 'smart':
    default:
      return adminLayoutConfig; // Default fallback
  }
};

export const PUBLIC_NAVIGATION = [
  { name: 'Home', href: '/' },
  { name: 'Services', href: '/services' },
  { name: 'Providers', href: '/providers' },
  { name: 'How It Works', href: '/how-it-works' },
  { name: 'About', href: '/about' },
  { name: 'Contact', href: '/contact' }
];

// ========================================
// HELPER FUNCTIONS FOR ROUTE MANAGEMENT
// ========================================

// Check if a booking route is active
export const isBookingRouteActive = (currentPath: string, targetPath: string): boolean => {
  // Handle exact matches
  if (currentPath === targetPath) return true;
  
  // Handle parent-child relationships
  if (targetPath.endsWith('/bookings') && currentPath.startsWith(targetPath)) {
    return true;
  }
  
  return false;
};

// Get navigation badge count (you can connect this to your API)
export const getNavigationBadgeCount = (route: string, userRole: string): string | undefined => {
  // This would typically come from your API/state management
  // For now, returning static values as shown in the configs
  
  if (route === '/bookings/pending' && userRole === 'provider') return '3';
  if (route === '/bookings/accepted' && userRole === 'provider') return '2';
  if (route === '/account/bookings/pending' && userRole === 'user') return '1';
  if (route === '/account/bookings/accepted' && userRole === 'user') return '1';
  
  return undefined;
};

// Get breadcrumb path for any route
export const getBreadcrumbPath = (currentPath: string, userRole: string) => {
  const breadcrumbs = [];
  
  // Add role-specific dashboard
  if (userRole === 'admin') {
    breadcrumbs.push({ name: 'Admin Dashboard', href: '/dashboard' });
  } else if (userRole === 'provider') {
    breadcrumbs.push({ name: 'Provider Dashboard', href: '/dashboard' });
  } else if (userRole === 'user') {
    breadcrumbs.push({ name: 'Dashboard', href: '/dashboard' });
  }
  
  // Add booking-specific breadcrumbs
  if (currentPath.startsWith('/bookings')) {
    breadcrumbs.push({ name: 'Bookings', href: '/bookings' });
    
    if (currentPath.includes('/pending')) {
      breadcrumbs.push({ name: 'Pending', href: '/bookings/pending' });
    } else if (currentPath.includes('/accepted')) {
      breadcrumbs.push({ name: 'Active', href: '/bookings/accepted' });
    } else if (currentPath.includes('/completed')) {
      breadcrumbs.push({ name: 'Completed', href: '/bookings/completed' });
    }
  }
  
  if (currentPath.startsWith('/account/bookings')) {
    breadcrumbs.push({ name: 'My Account', href: '/account' });
    breadcrumbs.push({ name: 'My Bookings', href: '/account/bookings' });
    
    if (currentPath.includes('/pending')) {
      breadcrumbs.push({ name: 'Pending', href: '/account/bookings/pending' });
    } else if (currentPath.includes('/accepted')) {
      breadcrumbs.push({ name: 'Active Services', href: '/account/bookings/accepted' });
    } else if (currentPath.includes('/completed')) {
      breadcrumbs.push({ name: 'Completed', href: '/account/bookings/completed' });
    }
  }
  
  return breadcrumbs;
};